import React, { useEffect, useState, useRef, useContext } from 'react'
import { useDispatch, useSelector, ReactReduxContext } from 'react-redux'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { get, isEqual } from 'lodash'

import * as customPageActions from 'store/modules/customPage/actions'
import ResponseBlock from 'components/molecules/ResponseBlock'
import Pagination from 'components/molecules/Pagination'
import SearchFilters from 'components/organisms/SearchFilters'
import { userCheckMobileScreen } from 'helpers/tools'

import './SearchWidget.scss'

function SearchWidget(props) {
  const dispatch = useDispatch()
  const { store } = useContext(ReactReduxContext)
  const history = useHistory()
  const searchResultElement = useRef(null)

  const query = new URLSearchParams(history.location.search)
  const searchTerm = props.query || query.get('q')
  const sortOptions = [
    { name: 'Relevância', value: 'search_api_relevance', sortOrder: 'DESC' },
    { name: 'Mais recentes', value: 'created', sortOrder: 'DESC' },
    { name: 'Mais antigos', value: 'created', sortOrder: 'ASC' },
  ]

  const [currentPage, setCurrentPage] = useState(parseInt(query.get('page')) - 1 || 0)
  const [sortBy, setSortBy] = useState(query.get('sort_by') || 'search_api_relevance')
  const [sortOrder, setSortOrder] = useState(query.get('sort_order') || 'DESC')

  const { searchData, loadingSearch } = useSelector(({ customPage }) => customPage, isEqual)
  const totalPages = parseInt(get(searchData, 'searchQuery.pager.total_pages', 0))
  const totalItems = parseInt(get(searchData, 'searchQuery.pager.total_items', 0))
  const items = get(searchData, 'searchQuery.rows', [])
  const filtersData = get(searchData, 'searchQuery.content_types', {})

  let filters = []
  if (filtersData) {
    for (const key in filtersData) {
      filters.push({ name: filtersData[key], value: key, selected: query.getAll('type[]').includes(key) })
    }
  }
  const filtersFormat = [
    { name: 'Adobe Acrobat PDF (.pdf)', value: 'pdf', selected: query.getAll('doctype[]').includes('pdf') },
    { name: 'Microsoft Word (.doc)', value: 'doc', selected: query.getAll('doctype[]').includes('doc') },
    { name: 'Microsoft Excel (.xls)', value: 'xls', selected: query.getAll('doctype[]').includes('xls') },
    { name: 'Microsoft Powerpoint (.ppt)', value: 'ppt', selected: query.getAll('doctype[]').includes('ppt') },
  ]

  function handleSubmit() {
    if (searchTerm) {
      const payload = {
        doctype: query.getAll('doctype[]'),
        terms: searchTerm,
        sort_by: sortBy,
        sort_order: sortOrder,
        page: currentPage,
        limit: 10,
        type: query.getAll('type[]'),
        store: store,
      }
      dispatch(customPageActions.search(payload))
    }
  }

  function handleChangeOrder(option) {
    setSortBy(get(option, 'value'))
    setSortOrder(get(option, 'sortOrder'))
  }

  useEffect(() => {
    if (searchTerm) searchResultElement.current.scrollIntoView()
  }, [])

  useEffect(() => {
    if (!window.__SERVER_SIDE__) {
      handleSubmit()
    }
  }, [history])

  return (
    searchTerm && (
      <>
        <Container ref={searchResultElement} className="search-result-block">
          <Row>
            <Col>
              <section className="ResultText">
                <h3>
                  Estes são os resultados para busca por <strong>"{searchTerm}"</strong>
                </h3>

                <p>
                  Encontramos<strong>{totalItems} itens</strong>para sua consulta.
                </p>
              </section>
            </Col>
          </Row>
        </Container>

        <SearchFilters
          className="mb-3"
          filters={[
            {
              text: 'Categorias',
              selectAllText: 'Todas as categorias',
              field: 'type',
              items: filters,
            },
            {
              text: 'Formatos',
              field: 'doctype',
              selectAllText: 'Todas as formatos',
              items: filtersFormat,
            },
          ]}
          sort={{
            options: sortOptions,
            selected: sortOptions.find((option) => option.value === sortBy && sortOrder === option.sortOrder),
            handleChange: handleChangeOrder,
          }}
        />

        <Container>
          <Row>
            <Col>
              {loadingSearch && <Spinner size="lg" className="mb-5 d-flex justify-content-center" animation="border" />}
              {!loadingSearch &&
                Array.isArray(items) &&
                items.map(({ id, title, summary, url, thumbnail, type }) => (
                  <ResponseBlock
                    key={id}
                    title={title}
                    preview={summary}
                    link={url}
                    linkType={type}
                    thumbnail={{ src: thumbnail || '/sites/default/files/public/svg_icons/clipboard-medicine.svg' }}
                  />
                ))}
            </Col>
          </Row>
        </Container>

        {totalItems > 0 && (
          <Pagination
            initialPage={currentPage}
            totalPages={totalPages}
            onChangePage={(page) => setCurrentPage(page - 1)}
            paginationOffset={userCheckMobileScreen() ? 1 : 3}
            useQueryParams
          />
        )}
      </>
    )
  )
}

export default SearchWidget
